import { HEX_292D38, HEX_E2E5EB } from '@tanium/colors';
import { Border3, defineColor } from '@tanium/react-theme-definition';

export const HeaderUnderline = Border3;

export const SectionText = defineColor([HEX_292D38, HEX_E2E5EB]);
